const columns = [
  { title: 'Credit Date', dataIndex: 'creditDate', key: 'creditDate' },
  { title: 'Credit No.', dataIndex: 'creditNo', key: 'creditNo' },
  { title: 'Creditor', dataIndex: 'creditor', key: 'creditor' },
  { title: 'Name', dataIndex: 'name', key: 'name' },
  { title: 'Mobile No.', dataIndex: 'mobileNo', key: 'mobileNo' },
  { title: 'Previous Invoice Amount', dataIndex: 'prevInvoiceAmount', key: 'prevInvoiceAmount' },
  { title: 'Refund Amount', dataIndex: 'refundAmount', key: 'refundAmount' },
  { title: 'Remarks', dataIndex: 'remarks', key: 'remarks' },
];

export default columns;
